/*
Copyright 2023, 2024 New Vector Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

import {
  type ComponentPropsWithoutRef,
  type FC,
  useEffect,
  useState,
} from "react";
import { Button } from "@vector-im/compound-web";
import { useTranslation } from "react-i18next";
import { UserAddIcon } from "@vector-im/compound-design-tokens/assets/web/icons";

export const InviteButton: FC<
  Omit<ComponentPropsWithoutRef<"button">, "children">
> = ({ style, ...props }) => {
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(
    () =>
      typeof window !== "undefined" &&
      window.matchMedia("(max-width: 768px)").matches,
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 768px)");
    const handleChange = (e: MediaQueryListEvent): void => {
      setIsMobile(e.matches);
    };
    setIsMobile(mediaQuery.matches);
    mediaQuery.addEventListener("change", handleChange);
    return (): void => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, []);

  const label = t("action.invite");

  return (
    <Button
      kind="secondary"
      size="md"
      Icon={UserAddIcon}
      aria-label={label}
      title={label}
      style={{
        ...(isMobile ? { paddingInline: "10px", minWidth: "auto" } : {}),
        ...style,
      }}
      {...props}
    >
      {isMobile ? null : label}
    </Button>
  );
};